module.exports = __webpack_public_path__ + "static/media/bus.7ef25911.svg";